export default "__VITE_ASSET__BvgltmAG__"